import React from 'react';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import NotificationIcon from './notification-icon';
import NotificationDescription from './description';
import {
  DateText,
  ItemLayout,
  NotificationActions,
  NotificationIconContainer,
  NotificationInfoCtn,
  StyledDivider,
  StyledListItem,
  UnreadDotIcon
} from './styles';
import { getFormattedDate } from '#helper';

const NotificationListItem = ({
  notification,
  account,
  handleRead,
  handleDelete
}) => {
  const { id, log, timestamp, isRead } = notification;
  const formattedDate = getFormattedDate(timestamp, account);

  const handleReadNotification = () => {
    const read = isRead ? 0 : 1;
    handleRead(id, null, read);
  };

  return (
    <>
      <StyledListItem
        isRead={isRead}
        onClick={handleReadNotification}
      >
        <ItemLayout>
          <NotificationIconContainer>
            <NotificationIcon eventId={log.eventId} />
          </NotificationIconContainer>
          <NotificationInfoCtn>
            <DateText>
              {!isRead && <UnreadDotIcon />}
              {formattedDate}
            </DateText>
            <NotificationDescription
              notification={notification}
              handleReadNotification={handleReadNotification}
            />
          </NotificationInfoCtn>
          <NotificationActions>
            <IconButton
              onClick={e => {
                e.stopPropagation();
                handleDelete(id);
              }}
            >
              <DeleteIcon />
            </IconButton>
          </NotificationActions>
        </ItemLayout>
      </StyledListItem>
      <StyledDivider />
    </>
  );
};

export default NotificationListItem;
